import { forwardRef } from 'react';
import MuiSwitch, { type SwitchProps as MuiSwitchProps } from '@mui/material/Switch';

export type SwitchProps = MuiSwitchProps;

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  ({ color = 'primary', ...rest }, ref) => <MuiSwitch ref={ref} color={color} {...rest} />
);

Switch.displayName = 'Switch';
